// @ vendors
const Immutable = require('immutable');
// @ constants
const actionTypes = require('constants/actionTypes');

const initialState = Immutable.fromJS({
    inProgress: false,
    success: false,
    error: false,
    isValidated: false,
});

const ValidateDataAlreadyClient = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.VALIDATION_DATA_ALREADY_CLIENT_RESET:
            return initialState;
        case actionTypes.VALIDATION_DATA_ALREADY_CLIENT_REQUEST:
            return state.merge({
                inProgress: true,
                success: false,
                error: false,
                isValidated: false,
            });
        case actionTypes.VALIDATION_DATA_ALREADY_CLIENT_FAILURE:
            return state.merge({
                inProgress: false,
                success: false,
                error: true,
                isValidated: true,
            });
        case actionTypes.VALIDATION_DATA_ALREADY_CLIENT_SUCCESS:
            return state.merge({
                inProgress: false,
                success: true,
                error: false,
                isValidated: true,
            });
        default:
            return state;
    }
};

module.exports = ValidateDataAlreadyClient;
